import React from "react";
import HeroBg from "./../assets/illustrations/hero.svg";
import { PrimaryButtonWithIcon } from "./Buttons";

const Landing = () => {
  return (
    <div className="flex justify-center flex-col md:flex-row items-center mt-24">
      <div className="self-center w-full md:w-3/5">
        <h1 className="text-dark-blue text-6xl md:text-6xl font-extrabold">
          <span className="text-myOrange">The 360 Believer</span> Podcast
          Anchored By Clinton Adabanya.
        </h1>
        <p className="mt-8 md:w-10/12 text-justify font-medium">
          Listen to words, get answers to Bible questions, inspiring stories and
          practical lessons that will 10x the quality of your life.
        </p>

        <div className="mt-8 flex gap-4">
          <PrimaryButtonWithIcon
            btnText={"Podcast"}
            url="/podcasts"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-mic"
                viewBox="0 0 16 16"
              >
                <path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z" />
                <path d="M10 8a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0v5zM8 0a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V3a3 3 0 0 0-3-3z" />
              </svg>
            }
          />
          {/* <PrimaryButtonOutlineWithIcon
            btnText={"Blog"}
            url="/blog"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-journal-text"
                viewBox="0 0 16 16"
              >
                <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z" />
                <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z" />
                <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z" />
              </svg>
            }
          /> */}
        </div>
      </div>
      <div className="w-2/5 hidden md:block">
        <img src={HeroBg} alt="Hero SVG Icon" />
      </div>
    </div>
  );
};

export default Landing;
